import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import Checkbox from '@jd/jmtd/es/Checkbox';
import Radio from '@jd/jmtd/es/Radio';
import React from 'react';
import ConfigConsumer from '@jd/jmtd/es/ConfigConsumer';
export var SUMMARY_CARD = Symbol('summary card');
export default function SummaryCard(_ref) {
  var _children$type;

  var className = _ref.className,
      children = _ref.children,
      controlType = _ref.controlType,
      onChange = _ref.onChange,
      checked = _ref.checked,
      disabled = _ref.disabled,
      style = _ref.style;
  var Control = controlType === 'radio' ? Radio : controlType === 'checkbox' ? Checkbox : null;
  var propsByCardComponent = children === null || children === void 0 ? void 0 : (_children$type = children.type) === null || _children$type === void 0 ? void 0 : _children$type[SUMMARY_CARD]; // 卡片组件的属性，见IconSummaryCard和ColorSummaryCard

  var cardClassName = null;

  if (propsByCardComponent) {
    var _propsByCardComponent;

    cardClassName = (_propsByCardComponent = propsByCardComponent.cardClassName) === null || _propsByCardComponent === void 0 ? void 0 : _propsByCardComponent.call(propsByCardComponent, children.props);
  }

  return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
    var configSize = _ref2.size;
    return /*#__PURE__*/React.createElement("label", {
      style: style,
      className: classNames('jmtp-summary-card', className, cardClassName, {
        'jmtp-summary-card-checked': checked,
        'jmtp-summary-card-small': configSize === 'small' || configSize === 'mini'
      }),
      "data-event-name": Control ? checked ? 'uncheck' : 'check' : '',
      "data-event-content-selector": ".jmtp-summary-card-title .jmtd-label"
    }, /*#__PURE__*/React.createElement("div", {
      className: "jmtp-summary-card-content"
    }, Control && /*#__PURE__*/React.createElement(Control, {
      disabled: disabled,
      checked: checked,
      className: classNames('jmtp-summary-card-control', {
        'jmtp-summary-card-control-disabled': disabled
      }),
      onChange: onChange,
      size: configSize
    }), children));
  });
}
SummaryCard.propTypes = {
  style: PropTypes.any,
  children: PropTypes.any,
  className: PropTypes.any,
  controlType: PropTypes.string,
  onChange: PropTypes.any,
  checked: PropTypes.bool,
  disabled: PropTypes.bool
};
SummaryCard.defaultProps = {
  style: null,
  children: null,
  className: null,
  controlType: null,
  onChange: function onChange() {},
  checked: false,
  disabled: false
};